export var IntelligentPhotoCaptureEstimatorLabelTypeCode;
(function (IntelligentPhotoCaptureEstimatorLabelTypeCode) {
    IntelligentPhotoCaptureEstimatorLabelTypeCode["CLASSIFICATION"] = "CLASSIFICATION";
    IntelligentPhotoCaptureEstimatorLabelTypeCode["PRTC"] = "PRTC";
})(IntelligentPhotoCaptureEstimatorLabelTypeCode || (IntelligentPhotoCaptureEstimatorLabelTypeCode = {}));
//# sourceMappingURL=IntelligentPhotoCaptureEstimatorLabelTypeCode.js.map